import { Injectable } from '@angular/core';
import { BaseService } from './base.service';
import { HttpClient } from '@angular/common/http';
import { ModalService } from './modal.service';
import { URL_HELP_API } from 'environments/environment';
import { IsLoadingService } from './is-loading.service';
import { Estado } from 'app/models/veiculo/estado';
import { ResponseBase } from 'app/interfaces/response-base';

@Injectable({
  providedIn: 'root'
})
export class EstadoService extends BaseService<Estado> {

  constructor(
    protected httpClient: HttpClient,
    protected modalService: ModalService,
    protected isLoadingService: IsLoadingService) {
    super(httpClient, modalService, isLoadingService);
  }

  lista() {
    return new Promise<ResponseBase<Array<Estado>>>((resolve, reject) => {
      this.get(`${URL_HELP_API.ESTADOS.LISTA}`)
        .subscribe(
          (data: ResponseBase<Array<Estado>>) => {
            resolve(data);
          },
          err => {
            this.modalService.error(err.message || err.error || err), reject(err);
          }
        );
    });
  }
}
